/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SMSMessage } from '../model';
// @ts-ignore
import type { SortColumn } from '../model';
// @ts-ignore
import type { SortDirection } from '../model';
/**
 * SMSApi - axios parameter creator
 * @export
 */
export const SMSApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sMSControllerDeleteAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sms/deleteAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sMSControllerDeleteSMS: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('sMSControllerDeleteSMS', 'requestBody', requestBody)
            const localVarPath = `/api/sms/deleteSMS`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SortColumn} sortColumn 
         * @param {SortDirection} sortDirection 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sMSControllerGetSMSMessages: async (sortColumn: SortColumn, sortDirection: SortDirection, firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortColumn' is not null or undefined
            assertParamExists('sMSControllerGetSMSMessages', 'sortColumn', sortColumn)
            // verify required parameter 'sortDirection' is not null or undefined
            assertParamExists('sMSControllerGetSMSMessages', 'sortDirection', sortDirection)
            const localVarPath = `/api/sms/getSMSMessages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SortColumn} sortColumn 
         * @param {SortDirection} sortDirection 
         * @param {string} sender 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sMSControllerGetSMSMessagesFromSender: async (sortColumn: SortColumn, sortDirection: SortDirection, sender: string, firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sortColumn' is not null or undefined
            assertParamExists('sMSControllerGetSMSMessagesFromSender', 'sortColumn', sortColumn)
            // verify required parameter 'sortDirection' is not null or undefined
            assertParamExists('sMSControllerGetSMSMessagesFromSender', 'sortDirection', sortDirection)
            // verify required parameter 'sender' is not null or undefined
            assertParamExists('sMSControllerGetSMSMessagesFromSender', 'sender', sender)
            const localVarPath = `/api/sms/getSMSMessagesFromSender`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (sortColumn !== undefined) {
                localVarQueryParameter['sortColumn'] = sortColumn;
            }

            if (sortDirection !== undefined) {
                localVarQueryParameter['sortDirection'] = sortDirection;
            }

            if (sender !== undefined) {
                localVarQueryParameter['sender'] = sender;
            }

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sMSControllerGetSMSQueueSize: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sms/getSMSQueueSize`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sMSControllerGetSMSTransports: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/sms/getSMSTransports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} phoneNumber 
         * @param {string} body 
         * @param {string} [sender] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sMSControllerSendSMSMessage: async (phoneNumber: string, body: string, sender?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phoneNumber' is not null or undefined
            assertParamExists('sMSControllerSendSMSMessage', 'phoneNumber', phoneNumber)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('sMSControllerSendSMSMessage', 'body', body)
            const localVarPath = `/api/sms/sendSMS`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (phoneNumber !== undefined) {
                localVarQueryParameter['phoneNumber'] = phoneNumber;
            }

            if (sender !== undefined) {
                localVarQueryParameter['sender'] = sender;
            }


    
            localVarHeaderParameter['Content-Type'] = 'text/plain';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SMSApi - functional programming interface
 * @export
 */
export const SMSApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SMSApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sMSControllerDeleteAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sMSControllerDeleteAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SMSApi.sMSControllerDeleteAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sMSControllerDeleteSMS(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sMSControllerDeleteSMS(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SMSApi.sMSControllerDeleteSMS']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SortColumn} sortColumn 
         * @param {SortDirection} sortDirection 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sMSControllerGetSMSMessages(sortColumn: SortColumn, sortDirection: SortDirection, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SMSMessage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sMSControllerGetSMSMessages(sortColumn, sortDirection, firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SMSApi.sMSControllerGetSMSMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {SortColumn} sortColumn 
         * @param {SortDirection} sortDirection 
         * @param {string} sender 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sMSControllerGetSMSMessagesFromSender(sortColumn: SortColumn, sortDirection: SortDirection, sender: string, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SMSMessage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sMSControllerGetSMSMessagesFromSender(sortColumn, sortDirection, sender, firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SMSApi.sMSControllerGetSMSMessagesFromSender']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sMSControllerGetSMSQueueSize(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sMSControllerGetSMSQueueSize(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SMSApi.sMSControllerGetSMSQueueSize']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sMSControllerGetSMSTransports(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sMSControllerGetSMSTransports(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SMSApi.sMSControllerGetSMSTransports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} phoneNumber 
         * @param {string} body 
         * @param {string} [sender] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sMSControllerSendSMSMessage(phoneNumber: string, body: string, sender?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SMSMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sMSControllerSendSMSMessage(phoneNumber, body, sender, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SMSApi.sMSControllerSendSMSMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SMSApi - factory interface
 * @export
 */
export const SMSApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SMSApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sMSControllerDeleteAll(options?: any): AxiosPromise<void> {
            return localVarFp.sMSControllerDeleteAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sMSControllerDeleteSMS(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.sMSControllerDeleteSMS(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SortColumn} sortColumn 
         * @param {SortDirection} sortDirection 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sMSControllerGetSMSMessages(sortColumn: SortColumn, sortDirection: SortDirection, firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<SMSMessage>> {
            return localVarFp.sMSControllerGetSMSMessages(sortColumn, sortDirection, firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {SortColumn} sortColumn 
         * @param {SortDirection} sortDirection 
         * @param {string} sender 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sMSControllerGetSMSMessagesFromSender(sortColumn: SortColumn, sortDirection: SortDirection, sender: string, firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<SMSMessage>> {
            return localVarFp.sMSControllerGetSMSMessagesFromSender(sortColumn, sortDirection, sender, firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sMSControllerGetSMSQueueSize(options?: any): AxiosPromise<number> {
            return localVarFp.sMSControllerGetSMSQueueSize(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sMSControllerGetSMSTransports(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.sMSControllerGetSMSTransports(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} phoneNumber 
         * @param {string} body 
         * @param {string} [sender] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sMSControllerSendSMSMessage(phoneNumber: string, body: string, sender?: string, options?: any): AxiosPromise<SMSMessage> {
            return localVarFp.sMSControllerSendSMSMessage(phoneNumber, body, sender, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SMSApi - object-oriented interface
 * @export
 * @class SMSApi
 * @extends {BaseAPI}
 */
export class SMSApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SMSApi
     */
    public sMSControllerDeleteAll(options?: RawAxiosRequestConfig) {
        return SMSApiFp(this.configuration).sMSControllerDeleteAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SMSApi
     */
    public sMSControllerDeleteSMS(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return SMSApiFp(this.configuration).sMSControllerDeleteSMS(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SortColumn} sortColumn 
     * @param {SortDirection} sortDirection 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SMSApi
     */
    public sMSControllerGetSMSMessages(sortColumn: SortColumn, sortDirection: SortDirection, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return SMSApiFp(this.configuration).sMSControllerGetSMSMessages(sortColumn, sortDirection, firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {SortColumn} sortColumn 
     * @param {SortDirection} sortDirection 
     * @param {string} sender 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SMSApi
     */
    public sMSControllerGetSMSMessagesFromSender(sortColumn: SortColumn, sortDirection: SortDirection, sender: string, firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return SMSApiFp(this.configuration).sMSControllerGetSMSMessagesFromSender(sortColumn, sortDirection, sender, firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SMSApi
     */
    public sMSControllerGetSMSQueueSize(options?: RawAxiosRequestConfig) {
        return SMSApiFp(this.configuration).sMSControllerGetSMSQueueSize(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SMSApi
     */
    public sMSControllerGetSMSTransports(options?: RawAxiosRequestConfig) {
        return SMSApiFp(this.configuration).sMSControllerGetSMSTransports(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} phoneNumber 
     * @param {string} body 
     * @param {string} [sender] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SMSApi
     */
    public sMSControllerSendSMSMessage(phoneNumber: string, body: string, sender?: string, options?: RawAxiosRequestConfig) {
        return SMSApiFp(this.configuration).sMSControllerSendSMSMessage(phoneNumber, body, sender, options).then((request) => request(this.axios, this.basePath));
    }
}

